<template>
  <!-- 赠险库 -->
  <div class="product main-container">
    <div class="content">
      <div class="search-box">
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" clearable filterable>
            <Option v-for="(bean, i) in companyList" :key="i" :value="bean.companyCode">{{ bean.companyName }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">业务类别</span>
          <Select v-model="searchParams.sellType" multiple :max-tag-count="1" clearable>
            <Option value="1">网销产品</Option>
            <Option value="3">经代产品</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">销售状态</span>
          <Select v-model="searchParams.salesStatus" clearable>
            <Option value="1">停售</Option>
            <Option value="2">在售</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>

      <div class="filterList" v-if="tableData.length > 0">
        <ul class="clearfix">
          <li v-for="(item, index) in filterList" @click="e => togglefilterList(item)" :class="{ active: item.active === true }">
            <span>{{ item.name }}</span>
            <span class="ivu-table-sort" v-if="index > 0" style="width: 21px">
              <i class="ivu-icon ivu-icon-md-arrow-dropup" :class="{ on: item.iconStatus === 2 }"></i>
              <i class="ivu-icon ivu-icon-md-arrow-dropdown" :class="{ on: item.iconStatus === 1 }"></i>
            </span>
          </li>
        </ul>
        <span class="proNum">
          共<span class="mainColor">{{ total }}</span
          >款产品
        </span>
      </div>
      <div class="list" v-if="tableData.length > 0" v-loading="listLoading">
        <div class="item clearfix" v-for="(item, index) in tableData" :key="index">
          <div class="title">
            <img v-if="item.dockChannel == 2" src="@static/images/smle-logo.png" />
            <span class="product-name" @click="goDetail(item)">{{item.title || item.productName }}</span>
            <!-- 预售 -->
            <img v-if="item.preSale == 1" class="icon-selltype" src="@static/images/product/icon_ys.png" />
            <!-- 不可售 -->
            <img v-else-if="item.salesStatus == 1" class="icon-selltype" src="@static/images/product/icon_unsale.png" />
            <template v-if="item.sellType">
              <img v-if="item.sellType.includes('1')" class="icon-selltype" src="@static/images/product/icon_wx.png" />
              <img v-else-if="item.sellType.includes('3')" class="icon-selltype" src="@static/images/product/icon_jd.png" />
            </template>
            <img v-if="item.publishStatus == 1" class="icon-selltype" src="@static/images/product/icon_status.png" />
          </div>

          <div class="container-item">
            <div class="first">
              <div class="descList clearfix" v-if="item.goodness">
                <div class="descItem" v-for="its in item.goodness.replace(/<br>/g, '\n').split(/[\n]/)">
                  <Icon type="ios-checkmark-circle-outline" color="#236dff" size="18" />
                  <span>{{ its }}</span>
                </div>
              </div>
              <div class="other clearfix" v-if="item.feature">
                <div class="otherItem" v-for="its in item.feature.replace(/<br>/g, '\n').split(/[\n]/)">
                  {{ its }}
                </div>
              </div>
              <div class="divide"></div>
            </div>
            <div class="center">
              <div class="fr num-box">
                <div>
                  <p class="text1">可用份额</p>
                  <p class="text2">{{ item.remainGiftNum || '0'}}份</p>
                </div>
                <div>
                  <p class="text1">未投保</p>
                  <p class="text2">{{ item.unPayGiftNum }}份</p>
                </div>
                <div>
                  <p class="text1">已投保</p>
                  <p class="text2">{{ item.payGiftNum }}份</p>
                </div>
                <span class="my-tag pointer" @click="$refs.shareRecordModal.open(item)">赠送记录</span>
              </div>
              <div class="fr company-logo">
                <img :src="item.companyIcon" />
              </div>
              <div class="fr resource-wrap">
                <div
                  @click="
                    $router.push({
                      name: 'promotional',
                      query: { productCode: item.productCode, productId: item.id, curNum: '0' }
                    })
                  "
                >
                  <img src="@static/images/product/icon_resource.png" alt="" /><span>文档资料</span>
                </div>
                <div
                  @click="
                    $router.push({
                      name: 'promotional',
                      query: { productCode: item.productCode, productId: item.id, curNum: '1' }
                    })
                  "
                >
                  <img src="@static/images/product/icon_poster.png" alt="" /><span>产品海报</span>
                </div>
              </div>
            </div>
            <div class="last">
              <div class="btn link-btn" :class="{ 'disabled': item.salesStatus == 1 || item.salemanJoinId == undefined || item.remainGiftNum == 0}" @click="$refs.getLinkModal.open(item)">获取投保链接</div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-if="tableData.length == 0">
        <div>
          <img src="@static/images/noData.png" alt />
        </div>
        <div>
          <span>暂无产品</span>
        </div>
      </div>
      <div class="pageBox" v-if="tableData.length > 0">
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
      </div>
    </div>
    <!-- 获取链接 -->
    <get-link-modal ref="getLinkModal" @refresh="refresh"></get-link-modal>
    <!-- 分享记录 -->
    <share-record-modal ref="shareRecordModal"></share-record-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { pageTool } from '@/api/mixins';
import getLinkModal from './components/getLinkModal';
import shareRecordModal from './components/shareRecordModal';
import { mechExportAll } from '@/api/httpList';
export default {
  mixins: [pageTool],
  components: {
    getLinkModal,
    shareRecordModal
  },
  props: {},
  data() {
    return {
      pageNo: 1,
      pageSize: 5,
      total: 0,
      searchParams:{
        descs:''
      },
      companyList: [], //公司列表
      //排序数据
      filterList: [
        {
          name: '默认排序',
          active: true,
          value: ''
        },
        {
          name: '已投保份数',
          iconStatus: 0,
          value: 'payGiftNum'
        },
        {
          name: '可用份额',
          iconStatus: 0,
          value: 'remainGiftNum'
        }
      ],
      tableData: [], //产品列表
      userType: '' //账号类别 1、运营 2、商户 3、下级机构
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted() {
    this.initListParams('/buz/giveawayProduct/querySalesmanProductList');
    this.geCompanyList();
  },
  activated() {
    this.getList();
  },
  methods: {
    goDetail(item) {
      window.open(item.url + '?isGiveawayProduct=1', '_blank');
    },
    refresh(item) {
      // this.tableData.find(i => item.id == i.id )
      item.remainGiftNum--;
    },
    exportAll() {
      const params = this.setListParams(JSON.parse(JSON.stringify(this.searchParams)));
      mechExportAll(params).then(res => {
        const fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
        const blob = new Blob([res.data]); //构造一个blob对象来处理数据
        //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        //IE10以上支持blob但是依然不支持download
        if ('download' in document.createElement('a')) {
          //支持a标签download的浏览器
          const link = document.createElement('a'); //创建a标签
          link.download = fileName; //a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click(); //执行下载
          URL.revokeObjectURL(link.href); //释放url
          document.body.removeChild(link); //释放标签
        } else {
          //其他浏览器
          navigator.msSaveBlob(blob, fileName);
        }
        this.listLoading = false;
      });
    },
    initFilter(arr) {
      arr.forEach((item, index) => {
        item.active = false;
        if (index == 0) {
          item.active = true;
        }
        if (item.iconStatus) {
          item.iconStatus = 0;
        }
      });
    },
    // 切换排序
    togglefilterList(item) {
      this.filterList.forEach(its => {
        this.$set(its, 'active', false);
        if (its.value != item.value) {
          its.iconStatus = 0;
        }
      });
      if (item.value != '') {
        //切换图标状态
        if (item.iconStatus === 0) {
          item.iconStatus = 1;
        } else if (item.iconStatus === 1) {
          item.iconStatus = 2;
        } else if (item.iconStatus === 2) {
          item.iconStatus = 1;
        }
      }
      this.$set(item, 'active', true);
      this.pageNo = 1;
      this.getList();
    },
    //设置查询参数
    setListParams(params) {
      this.pageSize = 5;
      let sellType = params.sellType || [];
      let insureType = params.insureType || [];
      params.sellType = sellType.length > 1 ? sellType.join('|') : sellType.length == 1 ? sellType.join(',') : '';
      params.insureType = insureType.length > 1 ? insureType.join('|') : insureType.length == 1 ? insureType.join(',') : '';
      const sortData = this.filterList.find(item => item.active == true); //排序数据
      if (sortData.iconStatus === 1) {
        // 降序
        params.descs = sortData.value;
      } else if (sortData.iconStatus === 2) {
        // 升序
        params.ascs = sortData.value;
      }
      return params;
    },
    listCallback(resData) {
      sessionStorage.removeItem('productName');
      sessionStorage.removeItem('productCode');
      resData.data.forEach(item => {
        if (item.titleLabel) {
          item.titleLabel = item.titleLabel.split(',');
        } else {
          item.titleLabel = [];
        }
      });
    },
    //列表保险公司
    geCompanyList() {
      let url = '/buz/insuranceCompany/getCompanies';
      this.$http({
        url: url,
        type: 'get'
      }).then(res => {
        this.companyList = res.data;
      });
    },
    insureUrl(url) {
      if (!url) {
        this.$notice.error('该产品暂无投保流程');
        return;
      }
      window.open(url);
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
